export const filtersMixin = {
  methods: {
    /*user filters*/

    filterUsersByStudentsAndExcludeOwnUser(data) {
      const filteredData = []

      for (let i = 0; i < data.length; i++) {
        if (data[i].value !== this.getUserId && data[i].groups.includes(3)) {
          filteredData.push(data[i])
        }
      }

      return filteredData
    },

    /*user role Attributions filters*/

    filterUserRoleAttributionsByStudents(fetchedData) {
      fetchedData.map((userRoleAttribution) => {
        userRoleAttribution.user.groups.map((group) => {
          if (group.name === 'Students') {
            this.students.push(userRoleAttribution)
          }
        })
      })

      this.sortUserByLastName(this.students)
    },

    /*table filter methods*/

    filterOnWeek(week, dataObject) {
      this.copyEntriesToTableData()

      // should show all entries if no value is selected
      if (week) {
        // filter on the week which comes as an input
        this.tableData = this.tableData.filter((item) => parseInt(item.weekNumber) === parseInt(week)) // ÄNDERUNG: parseInt(week) statt parseInt(this.week)
        return
      }
      this.sortByDateDesc({ data: this.tableData, dateColumn: 'task_start' })
    },

    filterOnUserId(type, userId) {
      switch (type) {
        case 'author student work reports':
        case 'author supervisor work reports':
          this.tableData = this.tableData.filter((item) => parseInt(item.author) === parseInt(userId))
          break
        case 'target student work reports':
          this.tableData = this.tableData.filter((item) => parseInt(item.work_report.author) === parseInt(userId))
          break
      }
    },

    filterOutUser(type, userId) {
      switch (type) {
        case 'author student work reports':
        case 'author supervisor work reports':
          this.tableData = this.tableData.filter((item) => parseInt(item.author) !== parseInt(userId))
          break
      }
    },

    filterOnVisibility(visibility, userId) {
      this.tableData = this.tableData.filter(
        (item) => parseInt(item.author) === userId || (visibility.includes(parseInt(item.visibility)) && parseInt(item.author) !== userId)
      )
    }
  }
}
